import React, {forwardRef, memo, useCallback, useContext, useImperativeHandle, useState} from "react";
import {ICellEditorParams} from "ag-grid-community/dist/lib/interfaces/iCellEditor";
import {MenuItem, Select} from "@mui/material";
import {snackbarTypes} from "../../../../../../util/state/globalVariables";
import {useTranslation} from "react-i18next";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";

const PeakDaySelectEditor = memo(forwardRef((props: ICellEditorParams, ref) => {
    const {t} = useTranslation(["translation", "pricing"]);
    const {dispatchGlobalData} = useContext(GlobalContext);
    const [value, setValue] = useState(props.value);

    function onChangeHandler(e: any) {
        let peakValueName = props.column.getColId() === 'peakDay' ? 'peakValue' : 'peakOffValue';
        const value = e.target.value;
        console.log('onChangeHandler', value);
        setValue(value);
        props.stopEditing();
        props.node.setData({...props.node.data, [props.column.getColId()]: value});
        if (props.column.getColId() === 'peakDay') {
            if (value === t('pricing:days.none').toUpperCase()) {
                if (props.node.data.peakOffDay === t('pricing:days.none').toUpperCase()) {
                    dispatchGlobalData({
                        type: 'SET_SNACKBAR',
                        payload: {
                            snackbar: {
                                message: t('pricing:peakMatrix.messages.peakDay&peakOffDayNotBeUndefined'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                } else {
                    props.node.setData({...props.node.data, [peakValueName]: null});
                    props.api.refreshCells({columns: [peakValueName]});
                }
            } else if (value === props.node.data.peakOffDay) {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('pricing:peakMatrix.messages.peakDay&peakOffDayNotBeEqual'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }
        } else {
            if (value === t('pricing:days.none').toUpperCase()) {
                if (props.node.data.peakDay === t('pricing:days.none').toUpperCase()) {
                    dispatchGlobalData({
                        type: 'SET_SNACKBAR',
                        payload: {
                            snackbar: {
                                message: t('pricing:peakMatrix.messages.peakDay&peakOffDayNotBeUndefined'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                } else {
                    props.node.setData({...props.node.data, [peakValueName]: null});
                    props.api.refreshCells({columns: [peakValueName]});
                }
            } else if (props.node.data.peakDay === value) {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('pricing:peakMatrix.messages.peakDay&peakOffDayNotBeEqual'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }
        }
        props.api.refreshCells({columns: [peakValueName]});
    }

    const imperativeHandle = useCallback(() => {
        console.log('useImperativeHandle', value, props);
        return {
            getValue: () => {
                return value;
            }
        };
    }, [value, props]);

    useImperativeHandle(ref, imperativeHandle);

    return (
        <Select
            ref={ref}
            style={{padding: '0 10px', minWidth: '150px'}}
            value={value}
            onChange={onChangeHandler}
            onBlur={() => props.stopEditing()}
        >
            {// @ts-ignore
                props.values.map((item: any) => (
                    <MenuItem key={item} value={item}>{item}</MenuItem>
                ))}
        </Select>
    );
}));

export default PeakDaySelectEditor;